import { useMutation } from '@gogame/query';
import { useLinkNavigate } from '@gogame/screens';

import { createAudience } from 'scenes/CustomAudiences/Audiences/sources/audiences';

import { audiencesDetailsLink } from '../../navigation';
import { create } from '../queryKeyFactory';

export const useCreateAudience = ({ refresh = true } = {}) => {
  const createAUMutation = useMutation(create(), createAudience, {
    successMessage: () => `Audience was created`,
    refresh: refresh,
  });
  const navigateToDetails = useLinkNavigate(audiencesDetailsLink);

  const handleAction = async (params) => {
    const data = await createAUMutation.mutateAsync(params);
    navigateToDetails({ id: data.id });
    return data;
  };

  return [handleAction, createAUMutation];
};
